let createShareBySumOrder = null;

$(function () {
  createShareBySumOrder = function (payload) {
    // emptyAllCart();
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/order/create-share-by-amount-order',
      data: payload,
    })
      .done(function (response) {
        const { data } = response;
        if (data.success) {
          if (
            data.payment_redirect_url !== undefined &&
            data.payment_redirect_url !== null
          ) {
            document.location.href = data.payment_redirect_url;
            return;
          }

          if (
            payload.payment_method !== 'payment_terminal' &&
            payload.payment_method !== 'payment_verifone_terminal'
          ) {
            emptyAllCart('completed_share_by_amount', payload.table_session_id);
          }

          if (payload.terminal_id !== undefined && payload.terminal_id !== '') {
            removeOrderProcessStatus(payload.terminal_id);
          }

          if (data.order_html !== undefined || data.item_count !== undefined) {
            const orderHtml =
              data.order_html !== undefined && data.order_html !== null
                ? data.order_html
                : '';
            $('.modal-backdrop').remove();

            const $confirmationStyle = $('#classic-location-products').data(
              'order-confirmation-toast-style'
            );
            $('.confirmation-toast').remove();
            if (orderHtml) {
              $('.confirmation-toast').remove();
              $('#content').append(
                '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                  (window.innerWidth >= 500 ? ' right: 0;' : '') +
                  ' width: 480px; display: none;">' +
                  '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                  ($confirmationStyle == 'compact' ? 'false' : 'true') +
                  '" data-delay="' +
                  ($confirmationStyle === 'compact' ? 100000 : 3000) +
                  '">' +
                  '  <div class="toast-header">' +
                  '    <strong class="mr-auto">Ordre registrert</strong>' +
                  '    <small></small>' +
                  '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                  '      <span aria-hidden="true">&times;</span>' +
                  '    </button>' +
                  '  </div>' +
                  '  <div class="toast-body">' +
                  orderHtml +
                  '  </div>' +
                  '</div>' +
                  '</div>'
              );
            }

            if (data.orderProducts && $confirmationStyle === 'compact') {
              showPreviousSaleBar(data.item_count, data.total_amount);

              const productsWithCount = [];

              data.orderProducts.forEach((product) => {
                const productDetail = `(${product.quantity})${product.name}`;
                productsWithCount.push(productDetail);
              });

              localStorage.setItem(
                'lastOrderProducts',
                JSON.stringify(productsWithCount)
              );
              localStorage.setItem('lastOrderTotal', data.total_amount);

              setLastOrderDetails();
            } else if (data.orderProducts && $confirmationStyle !== 'compact') {
              $('.confirmation-toast').css({ padding: '1rem' }).show();
              $('.confirmation-toast-box')
                .toast('show')
                .on('hidden.bs.toast', function () {
                  $('.confirmation-toast').attr('style', function (i, s) {
                    return (s || '') + 'padding: 0px !important;';
                  });
                });

              const productsWithCount = [];

              data.orderProducts.forEach((product) => {
                const productDetail = `(${product.quantity})${product.name}`;
                productsWithCount.push(productDetail);
              });

              localStorage.setItem(
                'lastOrderProducts',
                JSON.stringify(productsWithCount)
              );
              localStorage.setItem('lastOrderTotal', data.total_amount);

              setLastOrderDetails();
            }
          } else if (
            data.payment_data !== undefined &&
            data.payment_data !== null
          ) {
            const { terminal_id, terminal_number } = payload;
            if (terminal_id !== undefined && terminal_id !== '') {
              const wrapper = $('#process-orders-with-terminal-payments');
              if (wrapper.hasClass('d-none')) {
                wrapper.removeClass('d-none');
                wrapper.addClass('d-flex');
              }
              const clonedOrderCard = $('.order-card.clone').clone();
              clonedOrderCard.removeClass('clone d-none');
              clonedOrderCard.addClass('processing');
              clonedOrderCard.attr('id', terminal_id);
              clonedOrderCard.find('.terminal-number').text(terminal_number);
              const statusBadge = clonedOrderCard.find('.status-badge');
              statusBadge.addClass('processing text-primary');
              statusBadge.html(
                `Behandling <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
              );
              clonedOrderCard
                .find('.order-items')
                .text(locationCart.number_of_products);

              const cancelButton = clonedOrderCard.find('.cancel-btn');
              cancelButton.remove();

              const retryButton = clonedOrderCard.find('.retry-btn');
              retryButton.addClass('retry-btn-' + terminal_id);
              retryButton.attr('disabled', true);
              retryButton.attr('data-terminal-id', terminal_id);
              retryButton.attr('data-terminal-type', 'verifone');

              const showOrderButton = clonedOrderCard.find('.show-order');
              showOrderButton.remove();

              const cancelProcessButton = clonedOrderCard.find(
                '.cancel-payment-process'
              );
              cancelButton.addClass('cancel-payment-process-' + terminal_id);
              cancelProcessButton.attr('data-terminal-number', terminal_number);
              cancelProcessButton.attr('data-terminal-id', terminal_id);
              cancelProcessButton.attr('data-terminal-type', 'verifone');
              cancelProcessButton.addClass('disabled');
              cancelProcessButton.attr('disabled');

              if (!$('#' + terminal_id).length) {
                $('#processing-orders').append(clonedOrderCard);
              }

              const payload = {
                type: 'verifone',
                action: 'start_payment',
                verifoneSerialNumber: terminal_id,
                paymentData: data.payment_data,
                senderDeviceId: localStorage.getItem('deviceID'),
              };

              localStorage.setItem(
                'vt_' + terminal_id,
                JSON.stringify(payload)
              );

              sendWhenReady(window.globalSocket, JSON.stringify(payload));
            } else {
              localStorage.setItem(
                'verifone_payment_data',
                JSON.stringify(data.payment_data)
              );

              passVerifoneDataToWebView(data.payment_data);

              if (
                $('#paymentProcessSpinner').hasClass('d-none') &&
                !$('#paymentProcessError').hasClass('d-none')
              ) {
                $('#paymentProcessSpinner').removeClass('d-none');
                $('#paymentProcessError').addClass('d-none');

                const processingMessage =
                  $('#paymentStatus').data('processing-message') ||
                  'Processing Payment...';
                $('#paymentStatus').text(processingMessage);
                $('#retryPaymentButton').addClass('d-none');
              }
              $('#paymentProcessModal')
                .modal({
                  backdrop: 'static',
                  keyboard: false,
                })
                .on('shown.bs.modal', function () {
                  $('#retryPaymentButton').addClass('d-none');
                  $('#paymentProcessSpinner').removeClass('d-none');
                  $('#paymentProcessError').addClass('d-none');
                  const processingMessage =
                    $('#paymentStatus').data('processing-message') ||
                    'Processing Payment...';
                  $('#paymentStatus').text(processingMessage);
                  $('#cancelPaymentButton')
                    .html('<div class="loader"></div>')
                    .prop('disabled', true);
                })
                .on('hidden.bs.modal', function () {
                  $('#cancelPaymentButton')
                    .html(
                      $('#cancelPaymentButton').data('button-text') || 'Avbryt'
                    )
                    .prop('disabled', false);
                });
            }
          }

          if (
            payload.table_session_id &&
            $('#table-session-details-modal.show').length > 0 &&
            $('#table-session-details-modal').attr('data-table-session-id') ==
              payload.table_session_id &&
            $('#btnSyncState').hasClass('d-none')
          ) {
            $('#btnSyncState').removeClass('d-none').addClass('d-flex');
          }
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }

        errorPopupAlert(
          data.responseJSON.errors || 'Noe gikk galt under deling av beløp.'
        );
      });
  };
});
